import {REQUEST_USERS, REQUEST_USERS_FAILURE, REQUEST_USERS_SUCCESS} from "../../constant/UsersConstant";

const initialState = {
    users: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const usersReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_USERS:
            return {
                ...state,
                users: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_USERS_SUCCESS:
            return {
                ...state,
                users: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_USERS_FAILURE:
            return {
                ...state,
                users: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
